var map = {
	"./": 1357,
	"./Clutch": 2665,
	"./Clutch.js": 2665,
	"./NewUi": 2666,
	"./NewUi.js": 2666,
	"./OldUi": 2667,
	"./OldUi.js": 2667,
	"./index": 1357,
	"./index.js": 1357,
	"./style": 854,
	"./style.js": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4194;